import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import Echo from 'laravel-echo'
import Notifications, { notify } from '@kyvg/vue3-notification'

import Donut from 'vue-css-donut-chart'
import 'vue-css-donut-chart/dist/vcdonut.css'

window.Pusher = require('pusher-js');
if( process.env.MIX_PUSHER_APP_KEY && process.env.MIX_PUSHER_APP_CLUSTER ){
    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: process.env.MIX_PUSHER_APP_KEY,
        cluster: process.env.MIX_PUSHER_APP_CLUSTER,
        forceTLS: true,
        encrypted: true,
    auth: {
        headers: {
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
            'X-Socket-ID': window.Echo ? window.Echo.socketId() : null,
        },
    },
    authEndpoint: '/broadcasting/auth',
    enabledTransports: ['ws', 'wss'],

    })
}


createInertiaApp({
    progress: {
        delay: 100,
        color: '#3c4858',
        includeCSS: true,
        showSpinner: true,
    },
    resolve: name => require(`./Pages/${name}`),
    title: title => title ? `${title}`:'',
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
        app.config.globalProperties.$toast = {
            success: (text, options = {}) => notify({ type: 'success', text, ...options }),
            error: (text, options = {}) => notify({ type: 'error', text, ...options }),
            warning: (text, options = {}) => notify({ type: 'warn', text, ...options }),
            info: (text, options = {}) => notify({ type: 'info', text, ...options }),
        }

        app
            .mixin({ methods: { route : route } })
            .mixin(require('./base'))
            .use(Notifications)
            .use(plugin)
            .use(Donut)
            .mount(el)
    },
})
